<template>
  <w-icon-wrapper icon-name='work-download-icon'>
    <g
      id="_123_XLSX_Download"
      data-name="123_XLSX_Download"
      transform="translate(-973.12 289.75)"
    >
      <path
        id="Pfad_1"
        data-name="Pfad 1"
        d="M47.12,31.25h-14v24h2.87a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1h-.87v-20h10v6h6v8.63a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V37.25Zm0,6V34.08l3.17,3.17H47.12Z"
        transform="translate(940 -321)"
        fill="currentColor"
      />
      <path
        id="Pfad_2"
        data-name="Pfad 2"
        d="M43.06,47.59l.53-.54.06-.06,2.24-2.28a.785.785,0,0,0,0-1.1.74.74,0,0,0-1.07,0l-.98,1V40.16a.76.76,0,1,0-1.52,0V44.6l-.97-1.02a.749.749,0,0,0-1.07-.02.787.787,0,0,0-.23.56.764.764,0,0,0,.21.54l2.78,2.93Z"
        transform="translate(940 -321)"
        fill="currentColor"
      />
      <g
        id="Gruppe_1"
        data-name="Gruppe 1"
        transform="translate(940 -321)"
      >
        <path
          id="Pfad_3"
          data-name="Pfad 3"
          d="M40.1,51.96l.92-1.7h1.17L40.76,52.7l1.47,2.48H41.05l-.95-1.72-.95,1.72H37.97l1.47-2.48-1.43-2.44h1.17l.92,1.7Z"
          fill="currentColor"
        />
        <path
          id="Pfad_4"
          data-name="Pfad 4"
          d="M43.75,54.37H45.9v.81H42.73V50.26h1.01v4.11Z"
          fill="currentColor"
        />
        <path
          id="Pfad_5"
          data-name="Pfad 5"
          d="M49.03,53.9a.529.529,0,0,0-.2-.44,2.591,2.591,0,0,0-.73-.32,4.664,4.664,0,0,1-.83-.34,1.363,1.363,0,0,1-.84-1.22,1.174,1.174,0,0,1,.22-.71,1.44,1.44,0,0,1,.65-.49,2.422,2.422,0,0,1,.94-.18,2.225,2.225,0,0,1,.94.19,1.487,1.487,0,0,1,.64.54,1.433,1.433,0,0,1,.23.79H49.04a.678.678,0,0,0-.21-.53.848.848,0,0,0-.6-.19.891.891,0,0,0-.58.16.494.494,0,0,0-.21.41.474.474,0,0,0,.24.4,2.552,2.552,0,0,0,.71.3,2.951,2.951,0,0,1,1.26.65,1.314,1.314,0,0,1,.4.96,1.175,1.175,0,0,1-.48,1,2.132,2.132,0,0,1-1.3.36,2.463,2.463,0,0,1-1.03-.21,1.637,1.637,0,0,1-.71-.57,1.479,1.479,0,0,1-.24-.84h1.02c0,.54.32.81.97.81a.91.91,0,0,0,.56-.15.485.485,0,0,0,.2-.41Z"
          fill="currentColor"
        />
        <path
          id="Pfad_6"
          data-name="Pfad 6"
          d="M52.49,51.96l.92-1.7h1.17L53.15,52.7l1.47,2.48H53.44l-.95-1.72-.95,1.72H50.36l1.47-2.48L50.4,50.26h1.17l.92,1.7Z"
          fill="currentColor"
        />
      </g>
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconDownloadExcel' };
</script>
